export default __webpack_public_path__ + "static/media/404-cones.12c901ef.png";